import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Entity } from 'app/pages/product/product.model';
import { SystemService } from 'app/services/system.service';
import { Team } from './team.model';
import { TeamService } from './team.service';

@Component({
  selector: 'team-form',
  templateUrl: './team-form.component.html',
  styleUrls: ['./team-form.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class TeamFormComponent implements OnInit {

    public teamForm: FormGroup;
    public action: string;
    public team: Team;
    public users: Entity[];
    format: any = { add: 'Agregar', remove: 'Quitar', all: 'Todos',
             none: 'Niguno', direction: 'left-to-right', draggable: false, locale: undefined };

    @Output()
    entityChanged: EventEmitter<any> = new EventEmitter();

    @Input()
    title: string;
    
    constructor(private _formBuilder: FormBuilder,
                private teamService: TeamService, 
                public _systemService: SystemService,
                private _matSnackBar: MatSnackBar) {
        // this.team = new Team();
     }

    ngOnInit(): void {
        // this.teamForm = this.createTeamForm();
         this.users = this._systemService.allUsers;
    }

    guardarTeam(): void{
        const theTeam: any = this.teamForm.getRawValue();
        theTeam.members = this.team.members;
        this.teamService.guardarTeam(theTeam)
            .subscribe(resp => {
                 // Show the success message
                 this._matSnackBar.open('Equipo guardado', 'OK', {
                    verticalPosition: 'top',
                    duration        : 4000
                });
                 this.entityChanged.emit(resp);
            });
    }

    deleteTeam(): void{

    }

    selected(entity: Entity): void{
        if (entity.id > 0) {
            this.teamService.getTeam(entity.id)
                .subscribe(
                    resp => {
                        this.team = new Team(resp);
                        this.teamForm = this.createTeamForm();
                        this.ngOnInit();
                    }
                );

        }else{
            this.team = new Team(entity);
            this.teamForm = this.createTeamForm();
            this.ngOnInit();
        }
        
    }

    createTeamForm(): FormGroup
    {
        return this._formBuilder.group({
            id                  : [this.team.id],
            name                : [this.team.name],
            description         : [this.team.description],
        });
    }

}
